/**
 * A per-frame easing factor written for 60Hz (the prototype's), scaled to the
 * frame's length so it eases at the same rate on faster displays.
 */
export const lag = (ease: number, dt: number) =>
    1 - Math.pow(1 - ease, dt * 60);
